import { render, staticRenderFns } from "./IconGreyScale.vue?vue&type=template&id=e1ac0c32&"
import script from "./IconGreyScale.vue?vue&type=script&lang=ts&"
export * from "./IconGreyScale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports